import { render } from "./RequestJobResetter.vue?vue&type=template&id=2d52a6ca"
import script from "./RequestJobResetter.vue?vue&type=script&lang=js"
export * from "./RequestJobResetter.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__